var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "card",
    attrs: {
      "elevation": _vm.elevation
    }
  }, [_vm.filter || _vm.searchString ? _c('v-card-title', {
    staticClass: "card-title"
  }, [_vm.filter ? [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Поиск",
      "clearable": "",
      "dense": "",
      "outlined": "",
      "rounded": "",
      "hide-details": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function callback($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  }), _c('v-spacer'), _vm._t("button")] : _vm._e(), _vm.searchString ? [_vm._t("searchString")] : _vm._e()], 2) : _vm._e(), _c('v-data-table', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll.self",
      value: _vm.tableScroll,
      expression: "tableScroll",
      modifiers: {
        "self": true
      }
    }],
    ref: "table",
    staticClass: "table",
    attrs: {
      "search": _vm.searchItem,
      "loading": _vm.tableLoading,
      "headers": _vm.tableHeaders,
      "items": _vm.tableItems,
      "single-select": _vm.singleSelect,
      "show-select": _vm.showSelect,
      "single-expand": _vm.singleExpand,
      "show-expand": _vm.showExpand,
      "height": _vm.height,
      "loading-text": "Загрузка",
      "hide-default-footer": "",
      "fixed-header": "",
      "custom-sort": _vm.customSort,
      "items-per-page": -1
    },
    on: {
      "change": function change(event) {
        return _vm.$emit('change', event);
      },
      "input": function input(event) {
        return _vm.$emit('input', event);
      },
      "item-expanded": _vm.showItemExpanded,
      "click:row": _vm.select
    },
    scopedSlots: _vm._u([_vm._l(Object.keys(_vm.$scopedSlots), function (slotName) {
      return {
        key: slotName,
        fn: function fn(slotScope) {
          return [_vm._t(slotName, null, null, slotScope)];
        }
      };
    })], null, true),
    model: {
      value: _vm.localValue,
      callback: function callback($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  }, [_c('template', {
    slot: "no-data"
  }, [_c('div', [_vm._v("Таблица пуста")])])], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }